import styled from "styled-components";
import {CFlexBetween, CFlexCenter, DText, FlexBetween} from "../../styles/CommonStyles";
import {FaExchangeAlt, FaChartLine, FaColumns} from "react-icons/fa";
import {GiCardExchange} from "react-icons/gi";
import Text from "../../utils/Text";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {HOME} from "../../constants/urls";
import {useMainContext} from "../../contexts/main";


const BottomBar = () => {

    const [active, setActive] = useState(-1)
    const navigate = useNavigate()

    const { main: { lang } } = useMainContext()

    console.log({ lang }, 'bottom bar')

    useEffect(() => {
        const pathname = window.location.pathname
        if (pathname.includes("otc"))
            setActive(1)
        else if (pathname.includes('markets'))
            setActive(2)
        else
            setActive(3)
    }, [])

    const onTabClicked = (idx) => {
        switch (idx) {
            case 0:
                window.location.href = HOME
                break
            case 1:
                window.location.href = HOME + "/trade/form"
                break
            case 2:
                navigate('/markets')
                break
            case 3:
                navigate('/')
                break
            default:
                break
        }
    }

    return (
        <Body>
            <FlexBetween>
                {tabs.map((tab, idx) => (
                    <CFlexBetween onClick={() => onTabClicked(idx)}>
                        <tab.icon size={18} active={idx === active} />
                        <DText color={active === idx && "#0d60a1"}><Text tid={tab.name} /></DText>
                    </CFlexBetween>
                ))}
            </FlexBetween>
        </Body>
    )
}


const DashboardIcon = styled(FaColumns)`
  color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
`
const MarketsIcon = styled(FaChartLine)`
  color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
`
const OtcIcon = styled(FaExchangeAlt)`
  color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
`
const WalletIcon = styled(GiCardExchange)`
  color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
`

const tabs = [
    { name: 'main', icon: DashboardIcon },
    { name: 'otc', icon: OtcIcon },
    { name: 'markets', icon: MarketsIcon },
    { name: 'p2p-trade', icon: WalletIcon },
]

const Body = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  direction: ${props => props.theme.english ? "ltr" : "rtl"};
  background-color: ${props => props.theme.mainBg};
  box-shadow: -2px 0 4px ${props => props.theme.mainBg};
  padding: 10px 20px;
  z-index: 100;
`


export default BottomBar;
